require('../sass/styles.scss');
require( 'datatables.net' )( window, $ );
require( 'datatables.net-bs4')( window, $ );
require('datatables.net-colreorder-bs4')(window, $);
require("chart.js/dist/Chart.min.js");
require("./modules/AjaxResponseActionHandler");

import ParticipantsInfo from "./modules/ParticipantsInfo";
import ParticipantsExport from "./modules/ParticipantsExport";
import ChangeCollapse from "./modules/ChangeCollapse";
import SpiderChart from "./modules/Chart";
import GoogleMaps from "./modules/GoogleMaps";
import Paypal from "./modules/Paypal";

global.ConmanagerInitMap = function() {
    $('.conmanager-google-map').each( function () {
        new GoogleMaps($(this));
    });
};

new ChangeCollapse();
$('.conmanager-radar-chart').each( function () {
    new SpiderChart($(this));
});

if ($('#paypalButtonContainer').length) {
    new Paypal('payment-wrapper', 'confirm-bank-transfer', 'paypalButtonContainer');
}

$(function(){
    new ParticipantsExport();
    new ParticipantsInfo();
    //open bootstrap tab on page reload
    $('.nav-tabs a[data-target*="' + window.location.hash + '"]').tab('show') ;

    //adding browser history on bootstrap tab change
    $('.nav-tabs a').on('shown.bs.tab', function (e) {
        e.preventDefault();
        $(this).tab('show');
        if($(this).is('[data-toggle="tab"]')) {
            history.pushState( null, null, $(this).attr('data-target') );
        }
    });
});